(function() {
    'use strict';

    angular
        .module('elogbooks.admin.core-clients')
        .controller('CoreClientsMarkupInfoController', CoreClientsMarkupInfoController);

    CoreClientsMarkupInfoController.$inject = [
        'coreClientMarkupResponse',
        'modulesService'
    ];

    function CoreClientsMarkupInfoController(coreClientMarkupResponse, modulesService) {
        var vm = this;
        vm.markup = coreClientMarkupResponse;
        vm.markup.readOnly = vm.markup.inactiveAt && new Date(vm.markup.inactiveAt) <= new Date();
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');
    }
})();
